export default __webpack_public_path__ + "static/media/streamline-ultimate_casino-chip-5-bold.6629c27d.svg";